import { Button } from '30pay/components';
import { HiArrowLeft, HiArrowRight } from 'react-icons/hi2';
import { __BuyPaymentDirectMethodProps } from './buyPaymentDirectMethod.intrface';
import ConvertBoxConfirmOrderModal from '30pay/trade/convertBox/confirmOrderModal/orderDetailModal.index';
import { useState } from 'react';
import { post } from 'scripts';
import { API } from 'data/30pay.api';
import { ConvertBoxDataType } from '30pay/trade/convertBox/convertBox.index';
import { useNavigate } from 'react-router-dom';

const BuyPaymentDirectMethod: React.FC<__BuyPaymentDirectMethodProps> = (props: __BuyPaymentDirectMethodProps) => {
    const [confirmData, setConfirmData] = useState<ConvertBoxDataType>();
    const [paymentUrl, setPaymentUrl] = useState<string>();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    function submitHandler() {
        setLoading(true);
        const { data } = props;
        const UUSDBody = {
            source: 1,
            platform: 1,
            amount: data?.srcValue,
            cardNumberId: data?.bankAccountId,
        };
        const CryptoBody = {
            ...UUSDBody,
            destinationSymbol: data?.destCoin?.symbol,
            walletAddress: data?.walletAddress,
            network: data?.network?.network,
        };
        const api = data?.destCoin?.symbol === 'UUSD' ? API.orderTransaction.buyUUSD : API.orderTransaction.buyCrypto;
        const body = data?.destCoin?.symbol === 'UUSD' ? UUSDBody : CryptoBody;
        post<any>(api, body)
            .then((res) => {
                setConfirmData(props.data);
                if (res.value.value.paymentUrl) setPaymentUrl(res.value.value.paymentUrl);
            })
            .catch((e) => console.log(e))
            .finally(() => setLoading(false));
    }

    return (
        <div className="flex flex-col w-full h-full">
            <ConvertBoxConfirmOrderModal
                data={props.data}
                isOpen={!!confirmData}
                onClose={() => setConfirmData(undefined)}
                submitButton={{
                    title: 'انتقال به درگاه',
                    onClick: () => {
                        if (paymentUrl) navigate(paymentUrl);
                    },
                }}
            />
            <p className="text-black-80 text-sm font-medium">
                برای ثبت نهایی و مشاهده پیش فاکتور روی دکمه ادامه کلیک نمایید.
            </p>
            <div className="flex items-center w-full gap-4 mt-6">
                <Button loading={loading} onClick={submitHandler} className="w-full h-16" type="primary">
                    <HiArrowRight />
                    ادامه
                </Button>
                <Button onClick={props.onBack} className="w-full h-16 bg-background" type="text">
                    بازگشت
                    <HiArrowLeft />
                </Button>
            </div>
        </div>
    );
};
export default BuyPaymentDirectMethod;
